import { useEffect, useState } from "react";

/**
 * Reactive matchMedia — re-evaluates on viewport / input changes.
 */
export const useMediaQuery = (query) => {
  const get = () =>
    typeof window !== "undefined" && window.matchMedia?.(query).matches;

  const [matches, setMatches] = useState(get);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    setMatches(mq.matches);
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, [query]);

  return matches;
};

export default useMediaQuery;
